import { pushEvent } from '../googleTagManager/googleTagManagerUtils';

import type { TSetSearchDepartureEvent } from './types';

//functions
export const pushSearchDepartureSetEvent = (
	isCurrentLocation: boolean
): void => {
	const event: TSetSearchDepartureEvent = {
		event: 'search_departure_set',
		search_is_current_location: isCurrentLocation,
	};

	pushEvent(event);
};

export const pushSearchArrivalSetEvent = (): void => {
	pushEvent({ event: 'search_arrival_set' });
};

export const pushClickSearchRideButton = (): void => {
	pushEvent({ event: 'search_ride_button_clicked' });
};

export const pushClickMyWayButton = (): void => {
	pushEvent({ event: 'search_my_way_button_clicked' });
};
